import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import MergeRulePairTemplate from '../../components/MergeRulePairTemplate';
import api from '../../../../components/utils/api';
import { downloadCsv } from '../../../../components/utils/Utils';
import { DownloadIcon } from '@heroicons/react/outline';

const MergeRuleDetailPage = () => {
    const { mergeRuleId } = useParams();
    const [mergeRuleName, setMergeRuleName] = useState('')
    const [mergeRulePairs, setMergeRulePairs] = useState([])

    useEffect(() => {
        api.get(`/api/merge-rules/${mergeRuleId}`)
            .then(res => {
                setMergeRuleName(res.data.name)
                setMergeRulePairs(res.data.tags)
            })
            .catch(e => console.error(e))
    }, [mergeRuleId])

    const handleDownloadCsv = () => {
        const header = 'tag,paired_classes'
        const rows = mergeRulePairs.map(rep => `${rep.name},${rep.merged_classes.join('|')}`)
        downloadCsv(header, rows, `${mergeRuleName}_merge_rule.csv`)
    }

    return (
        <div>
            <div className='flex justify-end mb-3'>
                <button
                    onClick={handleDownloadCsv}
                    disabled={mergeRulePairs.length === 0}
                    className='flex items-center gap-1 p-2 text-gray-500 hover:text-gray-700 disabled:opacity-25 text-sm'
                    title='Download CSV'
                >
                    <DownloadIcon className='h-5 w-5' />
                    CSV
                </button>
            </div>
            {mergeRulePairs.map((rep, i) => <MergeRulePairTemplate
                key={i}
                representativeClass={rep.name}
                pairedClasses={rep.merged_classes}
            />)}
        </div>
    )
}

export default MergeRuleDetailPage